export const initGTM = () => {
  if (typeof window === "undefined") return;

  // Перевіряємо, чи GTM вже завантажено
  if (window.dataLayer && typeof window.dataLayer.push === "function") {
    return; // GTM вже ініціалізовано
  }

  const GTM_ID = "GTM-KMWRPZRF";

  if (document.getElementById("gtm-script")) return;

  const script = document.createElement("script");
  script.id = "gtm-script";
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    "gtm.start": new Date().getTime(),
    event: "gtm.js",
  });
};
